module.exports = __webpack_public_path__ + "static/media/logo-vertical-white.78d38417.png";